import { render, staticRenderFns } from "./UserRowDetails.vue?vue&type=template&id=79a1e353&"
import script from "./UserRowDetails.vue?vue&type=script&lang=js&"
export * from "./UserRowDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports